import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, toDisplayString as _toDisplayString, Fragment as _Fragment, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "bg-amber-500 rounded-xl p-3 md:p-4 text-white shadow-soft overflow-hidden min-w-0" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"flex items-center gap-2 mb-2\"><div class=\"w-8 h-8 bg-amber-400 rounded-lg flex items-center justify-center\"><svg class=\"w-5 h-5\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z\"></path></svg></div><span class=\"text-sm font-medium opacity-90\">Yard Waste</span></div>", 1)
const _hoisted_3 = { class: "text-lg md:text-xl font-bold truncate" }
const _hoisted_4 = { class: "text-xs md:text-sm opacity-80 truncate" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", { class: "text-base md:text-lg font-bold truncate" }, "Season Ended", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "text-xs md:text-sm opacity-80" }, "Resumes mid-April", -1)
const _hoisted_7 = { class: "bg-white rounded-xl max-w-lg w-full max-h-[80vh] overflow-y-auto shadow-xl" }
const _hoisted_8 = { class: "p-6" }
const _hoisted_9 = { class: "flex items-center justify-between mb-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-heading font-semibold text-primary-800" }, " Yard Waste & Leaf Collection ", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-5 h-5",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "space-y-4 text-primary-600" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " Yard Waste Collection "),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Season:"),
      /*#__PURE__*/_createTextVNode(" Mid-April through mid-November")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Schedule:"),
      /*#__PURE__*/_createTextVNode(" Every other Monday (opposite recycling) ")
    ]),
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("strong", null, "Provider:"),
      /*#__PURE__*/_createTextVNode(" Johns Disposal Service")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " What's Accepted "),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside space-y-1" }, [
      /*#__PURE__*/_createElementVNode("li", null, "Grass clippings"),
      /*#__PURE__*/_createElementVNode("li", null, "Garden debris"),
      /*#__PURE__*/_createElementVNode("li", null, "Small branches (under 8\" diameter, 4-ft. lengths)"),
      /*#__PURE__*/_createElementVNode("li", null, "Weeds and plant trimmings")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, "Preparation"),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside space-y-1" }, [
      /*#__PURE__*/_createElementVNode("li", null, "Use containers marked \"yard waste\" or paper bags"),
      /*#__PURE__*/_createElementVNode("li", null, "Bundle branches with twine"),
      /*#__PURE__*/_createElementVNode("li", null, "No plastic bags"),
      /*#__PURE__*/_createElementVNode("li", null, "Max weight: 50 lbs per container")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "bg-amber-50 p-3 rounded-lg border border-amber-200" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-amber-800 mb-1" }, " Fall Leaf Collection (City Service) "),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside space-y-1 text-amber-700" }, [
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createElementVNode("strong", null, "Season:"),
        /*#__PURE__*/_createTextVNode(" October through November")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, "Rake leaves to terrace (between sidewalk & curb)"),
      /*#__PURE__*/_createElementVNode("li", null, [
        /*#__PURE__*/_createTextVNode(" Must be out by "),
        /*#__PURE__*/_createElementVNode("strong", null, "7am on applicable Mondays")
      ]),
      /*#__PURE__*/_createElementVNode("li", null, "No leaves before October 12"),
      /*#__PURE__*/_createElementVNode("li", null, "Do NOT mix with branches, bricks, or grass"),
      /*#__PURE__*/_createElementVNode("li", null, "Keep clear of parked cars and catch basins")
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm mt-2 text-amber-600" }, " The city collects over 7,000 cubic yards of leaves each fall! ")
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " Christmas Tree Collection "),
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside space-y-1" }, [
      /*#__PURE__*/_createElementVNode("li", null, "First Monday in January"),
      /*#__PURE__*/_createElementVNode("li", null, "Remove all decorations and stands"),
      /*#__PURE__*/_createElementVNode("li", null, "Place at curb by 6am (do not bag)")
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("h3", { class: "font-semibold text-primary-800 mb-1" }, " Drop-Off Option "),
    /*#__PURE__*/_createElementVNode("p", null, "4551 S 52nd Street (FREE for residents)"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, "Tue/Thu 2-7pm, Sat 7:30am-3:30pm"),
    /*#__PURE__*/_createElementVNode("p", { class: "text-sm" }, " Leaves accepted in biodegradable paper bags ")
  ])
], -1)

import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showRules = ref(false);

// Greenfield, WI - Johns Disposal
// Foxwood Crossing is in Collection Area "Monday A"
// Yard waste season: Mid-April to mid-November
// Collected every other week, OPPOSITE of recycling weeks (B weeks)

const PICKUP_DAY = 1; // Monday (same day as garbage/recycling)

const isInSeason = computed(() => {
  const today = new Date();
  const month = today.getMonth(); // 0-indexed
  const day = today.getDate();

  // Mid-April (month 3, ~day 15) to mid-November (month 10, ~day 15)
  if (month > 3 && month < 10) return true;
  if (month === 3 && day >= 15) return true; // April 15+
  if (month === 10 && day <= 15) return true; // Through Nov 15
  return false;
});

const getNextPickupDate = () => {
  const today = new Date();
  const dayOfWeek = today.getDay();
  let daysUntilPickup = (PICKUP_DAY - dayOfWeek + 7) % 7;

  // If today is pickup day, return today. Otherwise, if pickup day passed this week, go to next week.
  if (daysUntilPickup === 0) {
    // Today is Monday - return today
  } else if (dayOfWeek > PICKUP_DAY) {
    // We're past Monday this week - jump to next Monday
    daysUntilPickup = 7 - dayOfWeek + PICKUP_DAY;
  }

  const nextPickup = new Date(today);
  nextPickup.setDate(today.getDate() + daysUntilPickup);
  return nextPickup;
};

// Yard waste is collected on OPPOSITE weeks from recycling (B weeks)
const isYardWasteWeek = computed(() => {
  // Use a known recycling pickup date as reference (A week)
  // Yard waste is the OPPOSITE week (B week)
  // Foxwood Crossing: June 2, 2026 is confirmed recycling week
  const referenceRecyclingDate = new Date("2026-06-01"); // Monday - green week = recycling
  const nextPickup = getNextPickupDate();

  const weeksDiff = Math.floor(
    (nextPickup.getTime() - referenceRecyclingDate.getTime()) /
      (7 * 24 * 60 * 60 * 1000)
  );

  // Yard waste is opposite of recycling, so odd weeks
  return weeksDiff % 2 !== 0;
});

const nextPickupText = computed(() => {
  const today = new Date();
  const nextPickup = getNextPickupDate();
  const daysUntil = Math.round(
    (nextPickup.getTime() - today.getTime()) / (24 * 60 * 60 * 1000)
  );

  if (isYardWasteWeek.value) {
    // This week is yard waste week
    if (daysUntil === 0) {
      return "Today";
    } else if (daysUntil === 1) {
      return "Tomorrow";
    } else {
      return "Monday"; // Just the day name - unambiguous
    }
  } else {
    // Next week is yard waste week
    return "Next Week";
  }
});

const pickupSubtext = computed(() => {
  if (isYardWasteWeek.value) {
    return "Yard waste pickup this week";
  } else {
    return "No pickup this week";
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (_unref(isInSeason))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(nextPickupText)), 1),
          _createElementVNode("p", _hoisted_4, _toDisplayString(_unref(pickupSubtext)), 1)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_5,
          _hoisted_6
        ], 64)),
    _createElementVNode("button", {
      onClick: _cache[0] || (_cache[0] = ($event: any) => (showRules.value = true)),
      class: "mt-2 text-xs underline opacity-80 hover:opacity-100 transition-opacity"
    }, " View rules → "),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      (showRules.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4",
            onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (showRules.value = false), ["self"]))
          }, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _createElementVNode("button", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (showRules.value = false)),
                    class: "p-2 text-primary-400 hover:text-primary-600 transition-colors"
                  }, _hoisted_12)
                ]),
                _hoisted_13
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]))
  ]))
}
}

})